"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var verallia = verallia || {};

verallia.LocalStorageUtils = function () {
    function _class() {
        _classCallCheck(this, _class);
    }

    _createClass(_class, null, [{
        key: "setKey",
        value: function setKey(key, value) {
            localStorage[key] = value;
        }
    }, {
        key: "getKey",
        value: function getKey(key) {
            return localStorage[key];
        }
    }, {
        key: "deleteKey",
        value: function deleteKey(key) {
            localStorage.removeItem(key);
        }
    }, {
        key: "deleteAllKeys",
        value: function deleteAllKeys() {
            localStorage.clear();
        }
    }]);

    return _class;
}();